import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Button from "@mui/material/Button";
import CloseIcon from "@material-ui/icons/Close";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import { styled } from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";
import { Typography } from "@material-ui/core";
import { useEffect } from "react";
import { useState } from "react";
import ReactToPrint from "react-to-print";
import PrintIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { formatDate } from "../../../../common/components/Helper/Utils";
import { SpinnerRoundFilled } from "spinners-react";
import { connect } from "react-redux";
import { fetchMemoHistory } from "../../dealer/actions/dealerAction";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";
const columns = [
  //{ id: "index", label: "Serial No", minWidth: 100 },
  { id: "memostatusdate", label: "Date", minWidth: 100 },
  {
    id: "memostatus",
    label: "Event Description",
    minWidth: 100,
  },
  {
    id: "username",
    label: "Team Member",
    minWidth: 100,
  },
  {
    id: "comments",
    label: "Comments",
    minWidth: 100,
  },
  // {
  //   id: "memostatus",
  //   label: "Status",
  //   minWidth: 100,
  // },
];

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));


export default function MemoHistoryModal(props) {
  const { open, handleClose, memoInvoice } = props;
  const [loader, setLoader] = useState(false);
  const [memoHistory, setMemoHistory] = useState([]);
  const [memoDetails, setMemoDetails] = useState(null);

  useEffect(() => {
    if (memoInvoice?.id) {
        
    setLoader(true);
    fetchMemoHistory(
      memoInvoice.id,
      (data) => {
        setMemoHistory(data || []);
        setMemoDetails(memoInvoice);
        setLoader(false);
        // console.log(data,"memo");
        
      },
);

    }
  }, [memoInvoice]);



  const getEvent = (tableData) => {
    switch (tableData?.memostatus) {
      case "Open":
        return (
          <>
            Memo Invoice <span style={{ fontWeight: "bold" }}>Created</span>
          </>
        );
      case "Converted To Sale":
        const inventoryIds = (tableData?.memoinventory?.inventory && tableData?.memoinventory?.inventory.length) ? tableData?.memoinventory?.inventory.map(item => item.inventoryid).join(', ') : "";
        return (
          <>
            <span style={{ fontWeight: "bold" }}>Convert To Sale</span> triggered for the inventory item(s) <span style={{ fontWeight: "bold" }}>{inventoryIds}</span>. Invoice Number : <span style={{ fontWeight: "bold" }}> {tableData?.memoinventory?.inventory[0]?.invoicenumber}</span>
          </>
        ); 
      case "Returned":
        const returnedInventories = (tableData?.memoinventory?.inventory && tableData?.memoinventory?.inventory.length) ? tableData?.memoinventory?.inventory.map(item => item.inventoryid).join(', ') : "";
        return (
          <>
            <span style={{ fontWeight: "bold" }}>Returned</span> the inventory item(s) <span style={{ fontWeight: "bold" }}>{returnedInventories}</span>
          </>
        );
      case "Closed":
        return (
          <>
            Memo Invoice <span style={{ fontWeight: "bold" }}>Closed</span>
          </>
        );
    }
  }
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={"xl"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{minWidth:"500px"}}
      >
        <div id="printable-content">
          <div style={{margin:"20px 0px"}}>
            <DialogTitle id="alert-dialog-title ">
               Memo Invoice History
              <IconButton
                onClick={() => {
                  handleClose();
                }}
                style={{ float: "right",margin:"-15px" }}
                className="noprint"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
          </div>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
              marginRight: "20px",
              marginBottom: "20px",
            }}
          >
            <ReactToPrint
              onBeforeGetContent={handleOnBeforeGetContent}
              onAfterPrint={handleAfterPrint}
              onBeforePrint={handleBeforePrint}
              removeAfterPrint
              trigger={() => (
                <Button
                  variant="contained"
                  color="primary"
                  className="text-capitalize primary-bg color-white noprint"
                  startIcon={<PrintIcon />}
                >
                  PRINT
                </Button>
              )}
              content={() => document.getElementById("printable-content")}
            />
          </div> */}
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              style={{ marginTop: "-20px" }}
            >
             {loader ? (
                <div
                 style={{
                   display: "flex",
                   justifyContent: "center",
                   alignItems: "center",
                   minHeight: "200px",
                   width: "600px",
                   margin: "-20px 0px"}}
                >
                  <SpinnerRoundFilled
                    size={51}
                    thickness={125}
                    speed={80}
                    color="rgba(57, 107, 172, 1)"
                 />
                </div>
                ) : (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: "20px",
                  width: "600px",
                }}
              >
                <div>
                  <div>
                    <Typography variant="subtitle2" style={{ textTransform: 'capitalize'}}>
                      Created By : {memoDetails?.createdbyname}{" "}
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="subtitle2">
                      Memo No : {memoDetails?.memonumber || "-"}{" "}
                    </Typography>
                  </div>
                  {/* <div>
                    <Typography variant="subtitle2">
                      Current Status : {invoice?.paymentstatus || "-"}{" "}
                    </Typography>
                  </div> */}
                </div>
                {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
               
              
              </div> */}
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div>
                    <Typography variant="subtitle2">
                       Current Status : {memoDetails?.status || "-"}
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="subtitle2">
                       Invoice Amount ($): {memoDetails?.totalprice || "-"}
                    </Typography>
                  </div>
                </div>
              </div>
              <TableContainer>
                <Table aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <StyledTableCell
                          key={column.id}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {memoHistory.length ? (
                      <>
                        {memoHistory.map((row, index) => {
                          return (
                            <TableRow hover tabIndex={-1} key={row.code}>
                              {columns.map((column) => {
                                const value = row[column.id];
                                let commentValue = "-";
                                if (column.id === "comments") {
                                  const inventories = row?.memoinventory?.inventory;
                                  if (Array.isArray(inventories) && inventories.length) {
                                    const comment = inventories.find((item) => item.comments)?.comments;
                                    commentValue = comment || "-";
                                  }
                                }

                                return (
                                  <>
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      {/* {column.format &&
                                        typeof value === "number"
                                        ? column.format(value)
                                        : column.id === "memostatusdate" && value
                                          ? // ? moment(value).format("MM/DD/YYYY")
                                          formatDate(value, "MM/DD/YYYY")
                                          : column.id === "index"
                                            ? index + 1
                                            : value || "-"} */}
                                            {(column.id === "memostatusdate" && value) ? formatDate(value, "MM/DD/YYYY") : 
                                            (column.id === "memostatus" && getEvent(row)) ? getEvent(row) : 
                                            (column.id === "comments") ? commentValue : 
                                            value ? value : '-'}
                                            {/* {column.id === "memostatus" && getEvent(row)}
                                            {(column.id !== "memostatus" && column.id !== "memostatusdate" && value) ? value : "-"} */}
                                    </TableCell>
                                  </>
                                );
                              })}
                            </TableRow>
                          );
                        })}{" "}
                      </>
                    ) : (
                      <TableCell colspan={12} style={{ textAlign: "center" }}>
                        <Typography variant="h6" className="color-BCBCBC">
                          No History Found
                        </Typography>
                      </TableCell>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
             )}
            </DialogContentText>
          </DialogContent>
        </div>
      </Dialog>
    </div>
  );
}